<template>
  <v-row>
    <v-col
      cols="12"
      sm="12"
      md="12"
    >
      <v-checkbox
        v-model="isActive"
        label="Permisos personalizados"
        hide-details
        @change="handleChange"
      />
      <small v-if="isActive" style="color: red;">
        NOTA: si se activa se tendrán que configurar los permisos por usuario y tipo de contentido
      </small>
      <v-btn
        v-if="!loading && isActive"
        block
        @click="handleSave"
        color="blue"
      >
        guardar permisos
      </v-btn>
      <div
        v-if="isActive && config"
      >
        <v-row style="padding-top: 10px;">
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
                <v-autocomplete
                  v-model="userFilter"
                  :items="activeUsers"
                  outlined
                  dense
                  item-text="Name"
                  item-value="ID"
                  label="Usuario"
                  hide-details
                />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            md="6"
          >
                <v-autocomplete
                  v-model="contentFilter"
                  :items="contentTypes"
                  outlined
                  dense
                  item-text="Name"
                  item-value="ID"
                  label="Contenido"
                  hide-details
                />
          </v-col>
        </v-row>
        <div
          v-for="user of activeUsers"
          :key="user.ID"
          style="padding: 10px 0;"
          v-show="!userFilter || user.ID === userFilter"
        >
          <div style="background-color: orange; padding: 5px; border-radius: 5px;">
            <b>{{user.Name}}</b>
            <div style="padding: 10px;">
              <div
                v-for="ct of contentTypes"
                :key="ct.ID"
                style="margin-bottom: 10px;background-color: #cccccc80;padding: 10px;border-radius:5px;"
                v-show="!contentFilter || ct.ID === contentFilter"
              >
                <b>{{ct.Name}} - {{ct.Type}}</b>
                <br/>
                <v-checkbox
                  v-for="p of permissions"
                  :key="`${user.ID}_${ct.ID}_${p}`"
                  :label="p"
                  multiple
                  :value="`${user.ID}_${ct.ID}_${p}`"
                  v-model="config"
                  hide-details
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <small style="color: red;">
        NOTA: si se activa se tendrán que configurar los permisos por usuario y tipo de contentido
      </small>
      <v-btn
        v-if="!loading"
        block
        @click="handleSave"
        color="blue"
      >
        guardar permisos
      </v-btn>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="orange"
        class="mb-0"
      />
    </v-col>
  </v-row>
</template>
<script>
import api from '@/services/api'
export default {
  props: {
    workspaceID: {
      type: String,
      required: true,
    },
    users: {
      type: Array,
      default: null,
    },
    contentTypes: {
      type: Array,
      default: null,
    },
    forceUpdateUser: {
      type: String,
      default: null,
    },
    forceUpdateContentType: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    isActive: false,
    activeUsers: null,
    loading: false,
    config: null,

    userFilter: null,
    contentFilter: null,
  }),
  computed: {
    permissions () {
      return ['access', 'add', 'update', 'delete']
    },
  },
  watch: {
    forceUpdateUser () {
      this.handleGetActiveUser()
    },
    forceUpdateContentType () {
    },
  },
  mounted () {
    this.handleGetActiveUser()
    this.handleGetConfig()
  },
  methods: {
    handleGetActiveUser () {
      if (!this.users || this.users.length === 0) return
      api.getActiveData ('system', 'v1/system/users/active-and-filtered', { activeUsersID: this.users })
        .then(response => {
          this.activeUsers = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    async handleGetConfig () {
      try {
        this.loading = true

        const aux = await new Promise((resolve) => api.getAllWithoutLimit ('dviewcontent', `v1/system/workspaces/${this.workspaceID}/user-content-type-permissions`)
          .then(response => {
            resolve(response)
          }))

        this.isActive = aux.length > 0 ? true : false
        this.config = aux.map(item => `${item.UserID}_${item.ContentID}_${item.Permission}`)


        this.loading = false
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
    handleChange () {
    },
    async handleSave () {
      try {
        this.loading = true
        if (!this.isActive) {
          let del = await new Promise((resolve) => api.deleteItem ('dviewcontent', `v1/system/workspaces/`, `${this.workspaceID}/user-content-type-permissions`)
            .then(response => {
              resolve(response)
            }))
          if (!del) {
            alert('ERROR')
            this.loading = false
            return
          }
        } else {
          const body = this.config.map(item => {
            const aux = item.split('_')
            return {
              UserID: aux.shift(),
              ContentID: aux.shift(),
              Permission: aux.shift()
            }
          })
          let put = await new Promise((resolve) => api.put ('dviewcontent', `v1/system/workspaces/${this.workspaceID}/user-content-type-permissions`, body)
            .then(response => {
              resolve(response)
            }))
          if (!put) {
            alert('ERROR')
            this.loading = false
            return
          }
        }
        this.loading = false
        alert('Actualizado correctamente')
        this.handleGetConfig()
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    },
  },
}
</script>
